import { SET_USER, SET_UNAUTHENTICATED, CLEAR_ERRORS, LOADING_UI, SET_NOTY, LOADING_USER, SET_EXPLOGIN, LOADING_PERMISTION, SET_MESSAGE_PERMISTION, UPDATE_ARTICLES_MANAGER } from '../types';
import axios from 'axios';

export const loginUser = (token, history) => (dispatch) => {
    console.log(history)
    dispatch({ type: LOADING_UI });
    axios.post('/login-with-google', token)
      .then(res => {
        setAuthorizationHeader(res.data.token);
        dispatch(getUserData());
        dispatch({
          type: SET_NOTY,
          payload: 'Đăng nhập thành công.'
      })
        history ? history.push(history.location.pathname) : history.push('/');
      })
      .catch(err => {
        dispatch({
          type: SET_NOTY,
          payload: 'Có lỗi xảy ra. Vui lòng làm mới lại trình duyệt.'
        })
      })
}

export const logoutUser = () => (dispatch) => {
    localStorage.removeItem('FBIdToken');
    delete axios.defaults.headers.common['Authorization'];
    dispatch({ type: SET_UNAUTHENTICATED});
}

export const getUserData = () => (dispatch) => {
  dispatch({ type: LOADING_USER });
    axios
    .get('/user')
    .then(res => {
        dispatch({
            type: SET_USER,
            payload: res.data
        })
        dispatch({
          type: SET_EXPLOGIN,
          payload: null
      })
    })
    .catch(err => {
      dispatch({
          type: SET_EXPLOGIN,
          payload: 'Hết phiên đăng nhập. Vui lòng đăng nhập lại.'
      })
    })
}

export const updateUserArticlesManager = (userId) => dispatch => {
  dispatch({ type: LOADING_PERMISTION });
  const domain = {
    domain: 'ntea.vn'
  }
  axios.post(`/user/${userId}/articlesmanager`, domain)
      .then(res => {
          dispatch({
              type: SET_MESSAGE_PERMISTION,
              payload: res.data.message
          })
          dispatch({
            type: UPDATE_ARTICLES_MANAGER,
            userId
        })
      })
      .catch(err => {
        console.log(err)
          // dispatch({
          //     type: SET_ERROR_PERMISTION,
          //     payload: err.data.error
          // })
      })
}

const setAuthorizationHeader = (token) => {
    const FBIdToken = `Bearer ${token}`;
        localStorage.setItem('FBIdToken', FBIdToken);
        axios.defaults.headers.common['Authorization'] = FBIdToken;
}
export const clearErrors = () => dispatch => {
  dispatch({ type: CLEAR_ERRORS });
}